import { ICreateSendCrmLink } from '../../../types/createSendCrm';

export const SET_CS_PENDING_CRM_LINK = 'SET_CS_PENDING_CRM_LINK';
export const CLEAR_CS_PENDING_CRM_LINK = 'CLEAR_CS_PENDING_CRM_LINK';
export const COMMIT_CS_PENDING_CRM_LINK = 'COMMIT_CS_PENDING_CRM_LINK';
export const CLEAR_CS_RECIPIENT_CRM_LINK = 'CLEAR_CS_RECIPIENT_CRM_LINK';
export const SET_CS_SHIPMENT_CRM_LINK = 'SET_CS_SHIPMENT_CRM_LINK';
export const SET_CS_CRM_OPPORTUNITY = 'SET_CS_CRM_OPPORTUNITY';

export const setCsPendingCrmLink = (payload: ICreateSendCrmLink) => ({
  type: SET_CS_PENDING_CRM_LINK,
  payload,
});

export const clearCsPendingCrmLink = () => ({
  type: CLEAR_CS_PENDING_CRM_LINK,
});

export const commitCsPendingCrmLink = (payload: { uid: string }) => ({
  type: COMMIT_CS_PENDING_CRM_LINK,
  payload,
});

export const clearCsRecipientCrmLink = (payload: { uid: string }) => ({
  type: CLEAR_CS_RECIPIENT_CRM_LINK,
  payload,
});

export const setCsShipmentCrmLink = (payload: ICreateSendCrmLink | null) => ({
  type: SET_CS_SHIPMENT_CRM_LINK,
  payload,
});

export const setCsCrmOpportunity = (payload: { uid: string | null; opportunityId: string }) => ({
  type: SET_CS_CRM_OPPORTUNITY,
  payload,
});
